import React, { useEffect, useState } from 'react';
import { SView, SInput, SText, STheme, SPage, SHr, Upload, SImage } from 'servisofts-component';
import { TouchableOpacity } from 'react-native-gesture-handler';
import SSocket from 'servisofts-socket';
import Container from '../../../Components/Container';

const title = (props) => {
    const [textareaValue, setTextareaValue] = useState("");
    const [title, setTitle] = useState("");
    const [loading, setLoading] = useState(false);
    const inputFotoRef = React.createRef();
    useEffect(() => {
        SSocket.sendPromise({
            component: "enviroments",
            type: "get",
            key: "info_tutorial_title",
        }).then((resp) => {
            if (!resp) return;
            if (resp.data) {
                setTitle(resp.data);
            }
        }).catch((e) => {
            console.log("Error al obtener la informacion de inversion", e);
        });

    }, []);

    const enviarInformacion = async () => {
        setLoading(true);
        try {


            await SSocket.sendPromise({
                component: "enviroments",
                type: "editar",
                data: {
                    key: "info_tutorial_title",
                    data: title
                }
            });

            const files = inputFotoRef.current.getValue();
            if (Array.isArray(files) && files.length > 0) {
                // console.log("resp", resp);

                Upload.sendPromise({ file: files[0].file }, SSocket.api.root + "upload/enviroments/info_tutorial_title")
            }

            await new Promise(resolve => setTimeout(resolve, 1000));

            // SNotification.send({ title: "Guardado correctamente" });
        } catch (e) {
            console.log("Error al guardar", e);
            // SNotification.send({ title: "Error al guardar", body: e.message, color: STheme.color.danger });
        } finally {
            setLoading(false);
        }
    }

    return (
        <SPage title={"Info Inversion"} >
            <Container>
                <SView
                    col={"xs-12"}
                    center
                    style={{
                        alignContent: "center",
                        justifyContent: "center",
                        padding: 10,
                        // maxWidth: 470,
                    }}
                >
                    <SText fontSize={20} color={STheme.color.text} center>
                        Ingresar titulo para tutoriales
                    </SText>
                    <SHr h={32} />
                    <SView row col={"xs-12"} center>
                        <SView width={60} height={60}>
                            <SInput
                                style={{ width: 60, height: 60, resizeMode: "cover" }}
                                type='image'
                                ref={ref => {
                                    if (ref) {
                                        inputFotoRef.current = ref
                                    }
                                }}
                                // placeholder=" Titulo del boton"
                                defaultValue={SSocket.api.root + "enviroments/info_tutorial_title"}
                            // style={{ marginVertical: 16, width: 450 }}
                            // onChangeText={setTitle}
                            />
                        </SView>
                        <SView flex >
                            <SInput
                                // ref={inputTitleRef}
                                placeholder="Titulo"
                                value={title}
                                style={{
                                    fontSize: 18, fontWeight: "bold"
                                }}
                                onChangeText={setTitle}
                            />
                        </SView>
                    </SView>

                    <SHr />
                </SView>

                <TouchableOpacity
                    disabled={loading}
                    style={{
                        width: 150,
                        height: 50,
                        marginTop: 16,
                        backgroundColor: loading ? STheme.color.warning : STheme.color.danger,
                        borderRadius: 8,
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    onPress={enviarInformacion.bind(this)}
                >
                    <SText color={STheme.color.white} fontSize={18}>
                        {loading ? "Guardando..." : "Guardar"}
                    </SText>
                </TouchableOpacity>
            </Container>
        </SPage>
    );
};

export default title;